module.exports = __webpack_public_path__ + "static/favicon-9cec163bffb727f0e63b98d2ff59aab7.ico";